import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import {
  getPlanCategory,
  getPlanMetrix,
  getPlanReport,
} from "../../../services/BillingHistory";
import SearchInputComponent from "./Common/SearchInputComponent";
import { downloadCSV } from "../../../helpers/dataTableHelper";

function PlanReport() {
  const { plan_id } = useParams();

  const columns = useMemo(
    () => [
      {
        name: "Recruiter name",
        selector: (row) => row.recruiter_name,
        wrap: true,
        width: "150px",
        sortable: true,
        sortField: "recruiter_id",
      },
      {
        name: "Company name",
        selector: (row) => row.company_name,
        wrap: true,
        width: "150px",
        //   sortable: true,
        sortField: "company_name",
      },
      {
        name: "Category name",
        selector: (row) => row.category_name,
        wrap: true,
        width: "130px",
        //   sortable: true,
        sortField: "category_name",
      },
      {
        name: "Plan name",
        selector: (row) => row.plan_name,
        //   wrap: true,
        //   sortable: true,
        sortField: "plan_name",
      },
      {
        name: "Total unlock",
        selector: (row) => row.total_unlock,
      },
      {
        name: "Total jobs",
        selector: (row) => row.total_jobs,
      },
      {
        name: "Total applicants",
        selector: (row) => row.total_applicants,
      },
      {
        name: "Total offers",
        selector: (row) => row.total_offers,
      },
    ],
    []
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [categories, setCategories] = useState([]);

  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
    sort_by: "created_at",
    sort_direction: "DESC",
    keyword: "",
    plan_id: plan_id,
  });
  const [fetch, setFetch] = useState(true);

  const fetchUsers = useCallback(
    (params) => {
      setLoading(true);
      getPlanReport(params)
        .then((res) => {
          setData(res?.data?.data);
          setTotalRows(res?.data?.total_count);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch]
  );

  useEffect(() => {
    if (fetch && reqParams?.plan_id) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams, fetchUsers]);

  const handleSearchText = useCallback(
    (text, isClear = false) => {
      if (text || isClear) {
        setReqParams((state) => {
          return { ...state, keyword: text };
        });
        setFetch(true);
      }
    },
    [setReqParams, setFetch]
  );

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleExtraFilter = useCallback(
    (filter) => {
      setReqParams((state) => {
        return { ...state, ...filter };
      });
      setFetch(true);
    },
    [setFetch, setReqParams]
  );

  const handleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        setReqParams({
          ...reqParams,
          sort_by: column.sortField,
          sort_direction: sortDirection,
        });
        setFetch(true);
      }
    },
    [reqParams, setReqParams, setFetch]
  );

  return (
    <>
      <div className="d-flex align-items-center mb-4 flex-wrap">
        <h4 className="fs-20 font-w600  me-auto">{""}</h4>
        <div>
          <button
            onClick={() => downloadCSV(data, "plan-report-")}
            className="btn btn-warning btn-sm me-2"
          >
            <i className="fas fa-file-csv me-1"></i> Export
          </button>
          <Link to="/plan-matrix">
            <button className="btn btn-primary btn-sm">
              <i className="fa fa-arrow-left"></i> Back
            </button>
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <DataTable
              className="table display dataTablesCard job-table table-responsive-xl card-table dataTable no-footer"
              columns={columns}
              data={data}
              progressPending={loading}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              subHeader
              subHeaderComponent={
                <SearchInputComponent setFilterText={handleSearchText} />
              }
              persistTableHead
              onSort={handleSort}
              sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default PlanReport;
